import { RESET_UNREAD_NOTIFICATION, SET_NOTIFICATION_COUNT } from './constants';

export const setNotificationCount = data => {
  return { type: SET_NOTIFICATION_COUNT, payload: data };
};

export const resetUnreadNotification = () => {
  return { type: RESET_UNREAD_NOTIFICATION };
};
